import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Documents = lazy(() => import('Pages/Screens/Client/Documents/Page'));

//* Portal do Cliente - rotas sob /cliente
const ClientRoutes: RouteObject[] = [
  {
    path: 'documents',
    element: React.createElement(LoadComponent, { component: Documents }),
  },
];

export default ClientRoutes;
